/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Mission Impact Auth API
 * OpenAPI spec version: v1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { ProblemDetails } from '../missionImpactAuthAPI.schemas';

import { instance } from '../../mutator-auth';
import type { ErrorType } from '../../mutator-auth';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Gets the HTML content for a specific version of a legal document in the specified language. Falls back to English if not available.
 * @summary Get legal document
 */
export const getLegalDocument = (
  type: string,
  version: string,
  language: string,
  options?: SecondParameter<typeof instance>,
  signal?: AbortSignal
) => {
  return instance<string>(
    { url: `/v1/legal-documents/${type}/versions/${version}/${language}`, method: 'GET', signal },
    options
  );
};

export const getGetLegalDocumentQueryKey = (type?: string, version?: string, language?: string) => {
  return [`/v1/legal-documents/${type}/versions/${version}/${language}`] as const;
};

export const getGetLegalDocumentQueryOptions = <
  TData = Awaited<ReturnType<typeof getLegalDocument>>,
  TError = ErrorType<ProblemDetails>,
>(
  type: string,
  version: string,
  language: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegalDocument>>, TError, TData>>;
    request?: SecondParameter<typeof instance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLegalDocumentQueryKey(type, version, language);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLegalDocument>>> = ({ signal }) =>
    getLegalDocument(type, version, language, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(type && version && language),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getLegalDocument>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetLegalDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof getLegalDocument>>>;
export type GetLegalDocumentQueryError = ErrorType<ProblemDetails>;

export function useGetLegalDocument<
  TData = Awaited<ReturnType<typeof getLegalDocument>>,
  TError = ErrorType<ProblemDetails>,
>(
  type: string,
  version: string,
  language: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegalDocument>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLegalDocument>>,
          TError,
          Awaited<ReturnType<typeof getLegalDocument>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLegalDocument<
  TData = Awaited<ReturnType<typeof getLegalDocument>>,
  TError = ErrorType<ProblemDetails>,
>(
  type: string,
  version: string,
  language: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegalDocument>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLegalDocument>>,
          TError,
          Awaited<ReturnType<typeof getLegalDocument>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLegalDocument<
  TData = Awaited<ReturnType<typeof getLegalDocument>>,
  TError = ErrorType<ProblemDetails>,
>(
  type: string,
  version: string,
  language: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegalDocument>>, TError, TData>>;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get legal document
 */

export function useGetLegalDocument<
  TData = Awaited<ReturnType<typeof getLegalDocument>>,
  TError = ErrorType<ProblemDetails>,
>(
  type: string,
  version: string,
  language: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegalDocument>>, TError, TData>>;
    request?: SecondParameter<typeof instance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetLegalDocumentQueryOptions(type, version, language, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
